import Cookies from 'js-cookie';
import ApiManager from '../api/manager';

class StockLocationAddToCart {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="StockLocationAddToCart"]'),
      quantityEl: id => document.querySelector(`#cart-stock-${id}`),
      apiManager: new ApiManager()
    };
  }

  async init() {
    const { moduleList } = this.config;
    const cartId = Cookies.get('cartId');

    moduleList().forEach(module => {
      const { initialized } = module.dataset;

      if (initialized) return;

      module.dataset.initialized = true;

      module.addEventListener('click', async e => {
        e.preventDefault();

        await this.addToCart(e, cartId);
      });
    });
  }

  async addToCart(e, cartId) {
    const { target } = e;
    const { productId, productDescription, itemcode, storeAddressId } = target.dataset;
    const quantityEl = this.config.quantityEl(productId);
    let value = parseInt(quantityEl.value, 10);

    if (value <= 0) {
      value = 1;
    }
    const postObj = {
      cartname: 'default',
      itemcode,
      description: productDescription,
      quantity: value
    };

    const response = await this.config.apiManager
      .post(`/api/v1/catalog/cart/${cartId}/add-item`, postObj)
      .then(res => res)
      .catch(() => false);

    if (!response) {
      StockLocationAddToCart.showToast(
        'error',
        'Er ging iets mis met het toevoegen van het product aan de winkelwagen'
      );
      window.dispatchEvent(new CustomEvent('updateCart'));
      return;
    }

    StockLocationAddToCart.showToast('success', 'Product toegevoegd aan winkelwagen');

    const shippingMethods = await this.getShippingMethods(cartId);
    let addresses = [];
    let shippingMethodName;

    if (storeAddressId === '1') {
      shippingMethodName = 'PickupInStoreShippingMethod';
    } else {
      shippingMethodName = 'PickupWascoShippingMethod';
    }
    const shippingMethod = shippingMethods.find(x => x.name === shippingMethodName);
    addresses = shippingMethod.usableAddresses;

    const address = addresses.find(x => x.externalId.trim() === storeAddressId.trim());

    if (!address) {
      console.error('Address not found');
      StockLocationAddToCart.showToast(
        'error',
        'Geen adres gevonden voor geselecteerde afhaal locatie'
      );
      window.dispatchEvent(new CustomEvent('updateCart'));
      return;
    }

    const itemIds = response.items.map(x => x.id);
    const date = shippingMethod.availableDates[0];
    const shippingMethodPost = {
      ShippingMethodId: shippingMethodName,
      CartName: 'default',
      AddressId: address.id,
      DeliveryDate: date,
      DeliveryAddress: address,
      CartItemIds: itemIds,
      Remark: null
    };
    const shippingPostRes = await this.config.apiManager
      .post(`/api/v1/catalog/cart/${cartId}/shippingmethod`, shippingMethodPost)
      .then(res => res)
      .catch(() => false);

    if (!shippingPostRes) {
      StockLocationAddToCart.showToast(
        'error',
        'Er ging iets mis met het selecteren van het ophaal adres'
      );
      window.dispatchEvent(new CustomEvent('updateCart'));
      return;
    }

    StockLocationAddToCart.showToast(
      'success',
      'Ophaal adres geselecteerd en verzendmethode toegepast'
    );
    window.dispatchEvent(new CustomEvent('updateCart'));
  }

  async getShippingMethods(cartId) {
    const response = await this.config.apiManager
      .get(`/api/v1/catalog/cart/${cartId}/shippingmethods`)
      .then(res => res[0].shippingMethods)
      .catch(() => false);

    return response || [];
  }

  static showToast(type, text) {
    window.dispatchEvent(
      new CustomEvent('toast', {
        detail: { type, text }
      })
    );
  }
}

export default StockLocationAddToCart;
